<div class="promotion-sheet">
    <!-- <div class="drag-handle"></div> -->
    <button matIconButton type="button" class="close" (click)="close()" matTooltipPosition="above">
        <mat-icon>close</mat-icon>
    </button>
    <div class="promotion-content">
        <p class="mat-body-large mt-2 mb-2">{{ "tmv.promotion-message" | translate }}</p>

        <div class="mb-2">
            @if(data.os == 'android') {
            @if(data.lang=="nl"){
            <a href="https://play.google.com/store/apps/details?id=be.ngi.topomapviewer.twa&l=nl" target="_blank">
                <img src="./assets/images/GetItOnGooglePlay_Badge_Web_color_Dutch.png" width="191.2" height="56.8" alt="" />
            </a>
            }
            @else if (data.lang=="fr") {
            <a href="https://play.google.com/store/apps/details?id=be.ngi.topomapviewer.twa&l=fr" target="_blank">
                <img src="./assets/images/GetItOnGooglePlay_Badge_Web_color_French.png" width="191.2" height="56.8"
                    alt="" />
            </a>
            }
            @else {
            <a href="https://play.google.com/store/apps/details?id=be.ngi.topomapviewer.twa&l=en" target="_blank">
                <img src="./assets/images/GetItOnGooglePlay_Badge_Web_color_English.png" width="191.2" height="56.8"
                    alt="" />
            </a>
            }
            }

            @if(data.os == 'ios') {

            @if(data.lang=="nl"){
            <a href="https://apps.apple.com/be/app/topomapviewer/id6752865628?l=nl" target="_blank">
                <img src="./assets/images/DownloadOnTheAppStore_Dutch.png" width="170.4" height="56.8" alt="" />
            </a>
            }
            @else if (data.lang=="fr") {
            <a href="https://apps.apple.com/be/app/topomapviewer/id6752865628?l=fr" target="_blank">
                <img src="./assets/images/DownloadOnTheAppStore_French.png" width="180" height="56.8" alt="" />
            </a>
            }
            @else {
            <a href="https://apps.apple.com/be/app/topomapviewer/id6752865628?l=en" target="_blank">

                <img src="./assets/images/DownloadOnTheAppStore_English.png" width="170.4" height="56.8" alt="" />
            </a>
            }
            }
        </div>
    </div>
</div>